import Feedback from '@/components/Company/Feedback/Index';
import SharedCompanyStats from '@/features/companyDashboard/common/SharedCompanyStats';

interface OpsCompanyStatsProps {
  isCompact?: boolean;
}

const OpsCompanyStats = ({ isCompact }: OpsCompanyStatsProps) => (
  <SharedCompanyStats feedback={<Feedback />} isCompact={isCompact} />
);

export default OpsCompanyStats;
